<template>
    <div class="flex flex-col w-screen h-screen overflow-x-hidden overflow-y-auto">
        <header class="bg-teal-dark">
            <div class="container flex items-center py-8">
                <router-link :to="{name: 'home'}">
                    <Logo class="w-48 lg:w-64"/>
                </router-link>
                <div class="ml-auto">
                    <div v-if="!authenticated && !onAuthPage">
                        <InlineLoginForm class="hidden md:flex" @success="onSuccessfulLogin"/>
                        <router-link
                            :to="{name: 'password.request'}"
                            class="hidden md:block mt-2 ml-1 text-sm text-white hover:text-white hover:underline">
                            Forgot your password?
                        </router-link>
                        <AppLink :to="{name: 'login'}" class="md:hidden" theme="primary-button">Login</AppLink>
                    </div>

                    <div v-else-if="authenticated" class="flex items-center pr-2 text-white space-x-4 sm:pr-0">
                        <span>Welcome {{ user.firstname }} {{ user.lastname }}</span>
                        <Menu as="div" class="ml-3 relative z-10">
                            <div>
                                <MenuButton
                                    ref="menuButton"
                                    class="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                                    <span class="sr-only">Open user menu</span>
                                    <div class="h-10 w-10 rounded-full overflow-hidden">
                                        <ProfileImage :image="user.profile_image"/>
                                    </div>
                                </MenuButton>
                            </div>
                            <transition
                                enter-active-class="transition ease-out duration-100"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95">
                                <MenuItems
                                    class="absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    <MenuItem v-slot="{ active }">
                                        <router-link :to="{name: 'profile'}"
                                                     :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">
                                            Your Profile
                                        </router-link>
                                    </MenuItem>
                                    <MenuItem v-slot="{ active }">
                                        <button
                                            ref="logoutButton"
                                            class="block cursor-pointer w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            @click="logout">
                                            Logout
                                        </button>
                                    </MenuItem>
                                </MenuItems>
                            </transition>
                        </Menu>

                    </div>
                </div>
            </div>
            <Navbar/>
        </header>
        <main class="flex-1 flex flex-col">
            <router-view/>
        </main>
        <footer class="bg-teal-dark text-white mt-auto">
            <div class="container py-14">
                <div v-html="$store.getters.content.footer_copy"/>

                <div class="border-t-4 border-green border-dotted my-12"></div>

                <div class="flex justify-between items-center">
                    <Logo class="w-44"/>
                    <img src="/images/ashfield-logo.png" alt="Ashfield Logo" class="w-52">
                </div>
            </div>
        </footer>
        <Notifications/>
        <LoginModal
            v-model:show="login.show"
            :message="login.message"
            :closeable="login.closeable"
            @success="onSuccessfulLogin"/>
    </div>
</template>

<script>

import {get} from "lodash";
import {mapGetters} from 'vuex';
import Logo from "@/Components/Logo";
import Navbar from "@/Components/Layout/Navbar.vue";
import {Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue';
import Notifications from "@/Components/Notifications.vue";
import LoginModal from "@/Components/Auth/LoginModal.vue";
import InlineLoginForm from "@/Components/Auth/InlineLoginForm.vue";
import Button from "@/Components/Button.vue";
import ProfileImage from "@/Components/ProfileImage.vue"
import AppLink from "@/Components/AppLink";

export default {

    data() {
        return {
            login: {
                show: false,
                closeable: false,
                message: ''
            }
        }
    },

    created() {
        document.addEventListener('unauthenticated', this.onUnauthenticated);
        document.addEventListener('show-login', this.onShowLogin);
    },

    components: {
        Logo,
        Navbar,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        InlineLoginForm,
        Notifications,
        LoginModal,
        Button,
        ProfileImage,
        AppLink
    },

    methods: {
        onUnauthenticated() {
            this.login = {
                show: true,
                closeable: false,
                message: 'Please sign back in to continue.'
            };
        },
        onShowLogin() {
            this.login = {show: true, closeable: true, message: ''}
        },
        onSuccessfulLogin() {
            this.login = {show: false};
            this.$store.dispatch('fetchUser');
        },
        logout() {
            this.$store.dispatch('logout');

            if (get(this.$route, 'meta.auth', false)) {
                this.$router.push('/');
            }
        }
    },

    computed: {
        ...mapGetters([
            'authenticated',
            'user',
        ]),
        onAuthPage() {
            return !!this.$route.meta.authPage;
        },
    },


    beforeUnmount() {
        document.removeEventListener('unauthenticated', this.onUnauthenticated);
        document.removeEventListener('show-login', this.onShowLogin);
    }
};

</script>
